// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rotate-device[data-v-6ba11952]{position:fixed;width:100vw;height:100%;z-index:10;background-color:#373534;padding:5vh 12vw;text-align:center}.rotate-device svg[data-v-6ba11952]{width:48px;height:48px}.content[data-v-6ba11952]{background-color:#fff;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
